/**
 * Um `fetch` com tempo MÁXIMO de espera.
 *
 * O `fetch` do navegador não tem teto por conta própria: a resposta pode SAIR do
 * servidor e nunca chegar ao aparelho (rede móvel que morre depois do envio), e
 * aí a promessa fica pendurada para sempre, sem erro e sem resposta. Quem estava
 * esperando por ela nunca sai do "carregando".
 *
 * Foi o que travou a porta em 15/09/2026: o servidor respondeu a conferência do
 * e-mail em 12ms (está no `api_log`) e a tela de login ficou em "Conferindo o
 * e-mail..." sem nenhuma saída, com o botão Entrar desabilitado.
 *
 * O `apiFetch` de `lib/api.ts` já faz isso para o que é autenticado, mas ele
 * importa o `auth-service` (token, refresh, Cognito): as portas do produto
 * (login, cadastro, convite) chamam rota PÚBLICA e não podem depender disso,
 * então o teto mora aqui, sozinho e sem dependência nenhuma.
 */

/** 8s, o mesmo do `apiFetch`. */
export const TETO_PADRAO = 8000

export async function fetchComTeto(
  url: string,
  opcoes: RequestInit = {},
  ms = TETO_PADRAO,
): Promise<Response> {
  const controlador = new AbortController()
  const teto = setTimeout(() => controlador.abort(), ms)
  try {
    return await fetch(url, { ...opcoes, signal: controlador.signal })
  } finally {
    clearTimeout(teto)
  }
}
